export enum StockDumpRescuePathStatusEnum {
    Unknown = 0, Operative = 1, NotOperative = 2, DoesNotApply = 3
}